export enum DATA_TYPE {
  NUMBER = 'number',
  DATE = 'date',
  PERCENT = 'percents',
  TEXT = 'text',
  MONEY = 'money',
}

export enum DATE_VIEW_TYPE {
  DATE = 'date',
  TIME = 'time',
  DATE_TIME = 'dateTime',
  TIME_DATE = 'timeDate',
}
